import React from "react";
import Context from "../../../Context";
import CrumbsProvider from "../../Misc/CrumbsProvider";
import Blocker from "../../Misc/Blocker";
import BigError from "../../Misc/BigError";
import ShipParam from "./ShipParam";
import Bunker from "../Bunker/Bunker";
import Flex from "../../Misc/Flex";
import { Link } from "react-router-dom";
import Crew from "../Crew/Crew";
import IndexTile from "../Index/IndexTile";
import SVGStorage from "../../Misc/SvgIcons/SVGStorage";
import SVGNuts from "../../Misc/SvgIcons/SVGNuts";
import ShipList from "./ShipList";
export default class Ship extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      ships: [],
      ship: {},
    };
  }
  componentDidMount() {
    this.load();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.shipId !== this.props.shipId) {
      this.load();
    }
  }
  load = async () => {
    this.setState({ pending: true });
    let ships = await this.context.api.qa("/ship/list", {
      search: [
        {
          field: "statetypecode",
          compare: "EQL",
          value: "enabled",
        },
      ],
    });

    let shipId = this.context.api.nullUuid;
    if (this.props.shipId) {
      shipId = this.props.shipId;
    } else {
      if (ships.length === 1) {
        shipId = ships[0].id;
      }
    }

    let ship = await this.context.api.q("/ship/get", { id: shipId });
    this.setState({ pending: false, ship, ships });
  };

  isAccessible = (essence) => {
    let access = this.context.user.classAccess[essence] || {};
    if (access.c || access.u || access.d) {
      return true;
    }
    return false;
  };

  render() {
    const { pending, ship } = this.state;

    const shipParams = {
      code: "IMO",
      mmsi: "MMSI",
      callsign: "Позывной",
      contractorname: "Владелец",
      countryname: "Страна",
      projectname: "Проект",
      harborname: "Порт",
    };

    const allTiles = {
      element: (
        <IndexTile
          key="element"
          link="/element/"
          icon={<SVGNuts />}
          iconColor="warning"
          title="Структура СТСиК"
          description="Структурная схема узлов судна"
          className="col"
          cardClass="bg-light-warning"
        />
      ),
      product: (
        <IndexTile
          key="product"
          link="/product/"
          icon={<SVGStorage />}
          iconColor="primary"
          title="Складские запасы"
          description="Перечень судовых складских позиций"
          className="col"
          cardClass="bg-light-primary"
        />
      ),
    };

    let availableTiles = [];

    Object.entries(allTiles).forEach(([key, tile]) => {
      if (this.isAccessible(key)) {
        availableTiles.push(tile);
      }
    });

    if (ship === false) {
      return <BigError title="Судно не найдено" />;
    }

    if (!pending && !ship?.id) {
      return <ShipList ships={this.state.ships} />;
    }
    return (
      <>
        <div className="d-flex align-items-center justify-content-center mh100">
          <div className="container">
            <Blocker on={pending}>
              <div className="row">
                {ship?.id && (
                  <div className="col-lg-4 ">
                    <CrumbsProvider title={ship.name} />
                    <div
                      className="sticky-top"
                      style={{ zIndex: 1, top: "120px" }}
                    >
                      <div className="text-center ">
                        <img alt="" src={window.appConfig.clientLogo} />
                        <h3 className="font-weight-boldest  font-size-h4 font-size-h1-lg">
                          <div className="text-dark-75 text-center break-all">
                            {ship.name}
                          </div>
                        </h3>
                        <div className="text-muted break-all">
                          {ship.description}
                        </div>
                      </div>

                      <div className="card card-custom gutter-b mt-5">
                        <div className="card-body">
                          {Object.entries(shipParams).map(([key, title]) => {
                            return (
                              <ShipParam
                                ship={ship}
                                key={key}
                                field={key}
                                title={title}
                              />
                            );
                          })}
                        </div>
                      </div>
                      <div className="row">{availableTiles}</div>
                    </div>
                  </div>
                )}
                <div className="col-lg-8  ">
                  {ship?.id && (
                    <>
                      <div className="mb-5">
                        <div className="card mb-5">
                          <div className="card-body py-5">
                            <Flex between>
                              <h3 className="mb-0">Судовой бункер</h3>
                              <div>
                                <Link to="/bunker/">Подробнее</Link>
                              </div>
                            </Flex>
                          </div>
                        </div>
                        <Bunker shipId={ship.id} embed />
                      </div>

                      <div className="mb-5">
                        <div className="card mb-5">
                          <div className="card-body py-5">
                            <Flex between>
                              <h3 className="mb-0">Экипаж</h3>
                            </Flex>
                          </div>
                        </div>
                        <Crew shipId={ship.id} embed />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </Blocker>
          </div>
        </div>
      </>
    );
  }
}
